import { render, staticRenderFns } from "./ShoppingForm.vue?vue&type=template&id=0a8629ff&scoped=true&"
import script from "./ShoppingForm.vue?vue&type=script&lang=js&"
export * from "./ShoppingForm.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingForm.vue?vue&type=style&index=0&id=0a8629ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8629ff",
  null
  
)

export default component.exports